import React from "react";
import { Modal, Button } from "react-bootstrap";
import { MyCoachingSessionSvg } from "../../../../../utils/SvgComps";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./CoachingServiceModal.scss"
function CoachingServicesModal({
  showModal,
  handleClose,
  firstBoxText,
  secondBoxText,
  firstBoxUrl,
  secondBoxUrl,
}) {
  let navigate = useNavigate();
  const {t} = useTranslation();
  return (
    <>
      <Modal
        show={showModal}
        onHide={handleClose}
        dialogclassName="modal-60w"
        aria-labelledby="contained-modal-title-vcenter"
        className="custom-modal caoch-slect-modal"
        centered
        size="md"
      >
        <Modal.Header closeButton className="p-4 border-0">
          <Modal.Title className="mentor-title mb-0">  <strong>{t("Please Select")}</strong></Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body invalidemailshowfp p-4">
          <div className="coachingbox">
            <div className="row">
              <div className="mb-botm col-md-12 col-lg-6 col-xl-6 partnercard mb-4">
                <div className="couching-frm-box cursor-pointer">
                  <div
                    className="cach-dcac w-100 text-center"
                    onClick={() => navigate(firstBoxUrl)}
                  >
                    <h6>{firstBoxText}</h6>
                    <div className="svg-bx"><img src="/images/Lesson-rafiki1.svg" className="img-fluid"/></div>
                  </div>
                </div>
              </div>

              <div className=" mb-botm col-md-12 col-lg-6 col-xl-6 partnercard mb-4">
                <div className="couching-frm-box cursor-pointer">
                  <div
                    className="cach-dcac w-100 text-center"
                    onClick={() => navigate(secondBoxUrl)}
                  >
                    <h6>{secondBoxText}</h6>

                    <div className="svg-bx"><img src="/images/4694404_4911 1.svg" className="img-fluid"/></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CoachingServicesModal;
